<template>
  <div>
    <!-- Table -->
    <b-table
      id="usersTable"
      v-if="getAvailableList"
      :fields="fields"
      :items="getUserList"
      striped
      bordered
      responsive
      hover
      stacked="lg"
      show-empty
      small
      class="users-table"
      :tbody-tr-class="rowClass"
    >
      <!-- Eliminado -->
      <template #cell(is_deleted)="row">
        <b-badge v-if="row.item.is_deleted" variant="danger">No</b-badge>
        <b-badge v-else variant="light">Sí</b-badge>
      </template>

      <!-- Nombre -->
      <template #cell(persona.nombre)="row">
        <span :class="{ 'text-muted': row.item.is_deleted }">{{ row.item.persona.nombre }}</span>
      </template>

      <!-- Email -->
      <template #cell(email)="row">
        <span :class="{ 'text-muted': row.item.is_deleted }">{{ row.item.email }}</span>
      </template>

      <!-- Profesión -->
      <template #cell(empleado.profesion)="row">
        <span :class="{ 'text-muted': row.item.is_deleted }">
          {{ row.item.empleado.profesion }}
        </span>
      </template>

      <!-- Fecha de ingreso -->
      <template #cell(empleado.fecha_ingreso)="row">
        <span :class="{ 'text-muted': row.item.is_deleted }">
          {{ row.item.empleado.fecha_ingreso }}
        </span>
      </template>

      <!-- Roles -->
      <template #cell(roles_checklist)="data">
        <b-badge
          v-for="role in data.item.roles_checklist"
          :key="role.id"
          :variant="getRoleVariant(role.name)"
          class="mr-1"
        >
          {{ role.name }}
        </b-badge>
        <span v-if="data.item.roles_checklist.length <= 0" class="text-danger">
          Sin roles asignados
        </span>
      </template>

      <!-- Acciones -->
      <template #cell(acciones)="row">
        <div class="d-flex flex-wrap align-items-center justify-content-end user-actions">
          <b-button size="sm" variant="light" class="btn-outline-black" @click="selectedUser = row.item">
            Detalle
          </b-button>

          <!-- El botón de "ver como", únicamente lo puede usar el usuario con rol "admin" -->
          <check-authorization
            :requiresRoles="['admin']"
            :show-alert="false"
            hide
            v-if="!row.item.is_deleted && !isAuthUserOrCloneUser(row.item.id)"
          >
            <b-button size="sm" variant="light" class="btn-outline-indigo" @click="viewAsUser(row.item.id)">
              Ver como
            </b-button>
          </check-authorization>

          <u-d-controls
            v-if="!row.item.is_deleted"
            :id="row.item.id"
            editPath="userModule/getUserToEdit"
            deletePath="userModule/deleteUser"
            :editPermissions="['editar usuarios']"
            :deletePermissions="['eliminar usuarios']"
            :hideDeleteAction="isAuthUserOrCloneUser(row.item.id)"
            @on-got-item="emitOnGotItem"
          ></u-d-controls>
        </div>
      </template>
    </b-table>
    <loading v-else></loading>

    <!-- Detalle en panel lateral -->
    <user-detail :user="selectedUser" @close="selectedUser = null" />
    <div v-if="isThereUsers">
      <paginator
        aria-controls="usersTable"
        :disabled="!getAvailableList"
        show-path="userModule/getUsers"
        :resource="getUsersResource"
      ></paginator>
    </div>
    <!-- End Table -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserDetail from '@/components/Users/UserDetail'

export default {
  name: 'UserList',

  components: {
    UserDetail
  },

  created () {
    this.submit()
  },

  data () {
    return {
      selectedUser: null,

      fields: [
        { key: 'is_deleted', label: 'Habilitado', sortable: true },
        { key: 'persona.nombre', label: 'Nombre', sortable: true },
        { key: 'email', label: 'Email' },
        { key: 'empleado.profesion', label: 'Profesión' },
        { key: 'empleado.fecha_ingreso', label: 'Fecha de ingreso', sortable: true },
        { key: 'roles_checklist', label: 'Roles' },
        { key: 'acciones', label: '', class: 'text-right' }
      ]
    }
  },

  computed: {
    ...mapGetters('userModule', [
      'getUserList',
      'isAuthUserOrCloneUser',
      'getAvailableList',
      'isThereUsers',
      'getUsersResource'
    ])
  },

  methods: {
    async submit () {
      const { error, message } = await this.$store.dispatch('userModule/getUsers')

      if (error) this.$notify({ error, message }, 'Usuarios')
    },

    getRoleVariant (role) {
      if (role === 'admin') return 'success'

      return 'primary'
    },

    async viewAsUser (id) {
      await this.$store.dispatch('userModule/getViewAsUser', id)
      this.$router.push({ name: 'Dashboard' })
      window.scrollTo(0, 0)
    },

    rowClass (item) {
      return item && item.is_deleted ? 'users-table__row--disabled' : ''
    },

    emitOnGotItem () {
      this.$emit('on-got-item')
    }
  }
}
</script>

<style lang="scss" scoped>
.users-table ::v-deep td {
  vertical-align: middle;
  font-size: 0.8rem;
}

.users-table ::v-deep .users-table__row--disabled td {
  background: #fafbfc;
}

.user-actions {
  gap: 0.35rem;
}

.user-actions ::v-deep .btn {
  white-space: nowrap;
}

.user-actions ::v-deep .mr-3 {
  margin-right: 0.35rem !important;
}
</style>
